"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var TypeStyle = require("typestyle");
var Colors = widgets_1.TabStyles.Colors;
exports.DataGridColors = {
    Selected: '#cde7f8',
    // Hover: Colors.F3,
    AltRow: Colors.F2,
    HeaderBorder: Colors.L5,
    HorizontalGridLine: Colors.L2_5,
    SelectedGridLine: 'white',
    VerticalGridLine: Colors.L4,
};
exports.FocusIndicatorStyleName = TypeStyle.style({
    $nest: {
        '& [role="gridcell"]:focus, & [role="columnheader"]:focus': {
            outline: 'none',
        },
        '&.focus-visible [role="gridcell"]:focus, &.focus-visible [role="columnheader"]:focus': {
            boxShadow: "inset 0 0 0 1px " + Colors.Focus,
        }
    }
});
//# sourceMappingURL=DataGridColors.js.map